export default Object.freeze({
  RESET_PAGINATION: '01',
  SHOWMORE: '02',
  RELOAD: '03',
});
